import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { fundApi } from "../services/api";

const C = {
  bg: "#0a0a0a",
  card: "#111",
  border: "rgba(255,255,255,0.08)",
  gold: "#C9A84C",
  teal: "#00D4C8",
  violet: "#7C5CFC",
  white: "#F2F6FA",
  muted: "#888780",
  red: "#FF3B5C",
};

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await fundApi.login(email.trim(), password);
      login({
        token: res.data.token,
        fund_name: res.data.fund_name,
        fund_id: res.data.fund_id,
        role: res.data.role,
      });
      navigate("/dashboard", { replace: true });
    } catch (err) {
      const detail =
        err?.response?.data?.detail ||
        err?.message ||
        "Login failed. Check your credentials.";
      setError(detail);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.bg,
        color: C.white,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 24px",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div style={{ width: "100%", maxWidth: 440 }}>
        {/* Logo + tagline */}
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <h1
            style={{
              fontFamily: "'Bebas Neue', sans-serif",
              fontSize: 44,
              letterSpacing: "0.06em",
              margin: 0,
              color: C.white,
            }}
          >
            reAImagination
          </h1>
          <p
            style={{
              fontFamily: "'Overpass Mono', monospace",
              fontSize: 12,
              letterSpacing: "0.18em",
              color: C.gold,
              textTransform: "uppercase",
              marginTop: 6,
              marginBottom: 0,
            }}
          >
            Portfolio Intelligence
          </p>
        </div>

        {/* Card */}
        <form
          onSubmit={handleSubmit}
          style={{
            background: C.card,
            border: `1px solid ${C.border}`,
            borderRadius: 12,
            padding: "32px 28px",
          }}
        >
          <h2
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 20,
              fontWeight: 700,
              margin: "0 0 24px",
              color: C.white,
            }}
          >
            Fund manager sign-in
          </h2>

          <label
            style={{
              display: "block",
              fontFamily: "'Overpass Mono', monospace",
              fontSize: 11,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: C.muted,
              marginBottom: 6,
            }}
          >
            Email
          </label>
          <input
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="khazanah@reaimagination.com"
            style={{
              width: "100%",
              padding: "12px 14px",
              background: "#0a0a0a",
              border: `1px solid ${C.border}`,
              borderRadius: 8,
              color: C.white,
              fontSize: 14,
              marginBottom: 18,
              outline: "none",
            }}
          />

          <label
            style={{
              display: "block",
              fontFamily: "'Overpass Mono', monospace",
              fontSize: 11,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: C.muted,
              marginBottom: 6,
            }}
          >
            Password
          </label>
          <input
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "12px 14px",
              background: "#0a0a0a",
              border: `1px solid ${C.border}`,
              borderRadius: 8,
              color: C.white,
              fontSize: 14,
              marginBottom: 24,
              outline: "none",
            }}
          />

          {error && (
            <div
              style={{
                background: "rgba(255,59,92,0.08)",
                border: `1px solid ${C.red}30`,
                borderRadius: 8,
                color: C.red,
                padding: "10px 14px",
                fontSize: 13,
                marginBottom: 18,
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            style={{
              width: "100%",
              padding: "14px 16px",
              background: C.gold,
              color: C.bg,
              border: "none",
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 700,
              cursor: submitting ? "not-allowed" : "pointer",
              opacity: submitting ? 0.6 : 1,
              letterSpacing: "0.04em",
            }}
          >
            {submitting ? "Signing in…" : "Sign in →"}
          </button>

          <p
            style={{
              fontFamily: "'Overpass Mono', monospace",
              fontSize: 11,
              color: C.muted,
              marginTop: 18,
              marginBottom: 0,
              textAlign: "center",
              letterSpacing: "0.04em",
            }}
          >
            Restricted to authorised fund managers.
          </p>
        </form>
      </div>
    </div>
  );
}
